import { EventTypes } from '@mc/track-event'
import { TrackingContainer } from '@mc/visibility'
import { FAQ as Faq } from 'components/FAQ'
import { trackCatalogPageRowViewed } from '../../events'
import { usePageData } from '../PageDataProvider'

export const FAQ = () => {
  const { slug } = usePageData()

  return (
    <TrackingContainer
      onFirstVisible={() =>
        trackCatalogPageRowViewed({
          rowName: 'faq_section',
          categorySlug: slug,
        })
      }
      config={{
        threshold: 0.3,
        duration: { visible: 500 },
      }}
    >
      <div className='container'>
        <Faq
          className='mc-my-10'
          eventType={EventTypes.CATALOG_PAGE_CLICK}
          eventLocation='faq-section'
          sections={['bogo', 'promo', 'general', 'pricing', 'sessions']}
        />
      </div>
    </TrackingContainer>
  )
}
